import { MenuButton } from '@szhsin/react-menu';
import styled from 'styled-components';

export const StyledCreatAgentModal = styled.div`
  width: 100%;
  color: var(--ink);

  .flex-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;

    .description {
      display: none;
      position: absolute;
      left: 40%;
      z-index: 5;
      padding: 5px;
      border-radius: 5px;
      border: 1px solid var(--line);
      background-color: var(--card);
      color: var(--ink);
      box-shadow: var(--shadow);
    }

    &:hover {
      .description {
        display: block;
      }
    }

    &.tag-section {
      justify-content: space-between;

      .tag-text {
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        padding: 5px 10px;
        border-radius: 10px;
        border: 1px solid rgb(157, 157, 157);
        text-transform: capitalize;
      }
    }
  }

  .memory-wrap {
    margin-bottom: 0;
    background: var(--card);
    border: 1px solid var(--line);
    border-radius: 22px;
    padding: 20px;
    box-shadow: var(--shadow);
    color: var(--ink);

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      margin-bottom: 16px;
      .memory-title {
        color: var(--ink);
        font-size: 14px;
        font-weight: 700;
        margin: 0;
      }
    }

    .memory-enable {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 20px;
      width: 100%;
      background-color: var(--card-warm);
      border-radius: 16px;
      border: 1px solid var(--line);
      margin-bottom: 20px;

      .stick-wrap {
        width: 48px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--o-tint);
        border-radius: 50%;

        img {
          width: 24px;
          height: 24px;
          color: var(--quiet);
        }
      }

      .enable-title {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        margin-bottom: 8px;
        color: var(--ink);
      }

      .enable-desc {
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        color: var(--quiet);
      }
    }

    .btn-check {
      position: relative;
      width: 45px;
      height: 26px;
      cursor: pointer;
      border-radius: 50px;
      background: #ccc;

      &.checked {
        background: var(--primary-gradient);

        &::before {
          left: 21px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 22px;
        height: 22px;
        transition: all ease-in-out 0.3s;
        border-radius: 50px;
        background: white;
      }
    }

    .memory {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
      padding: 14px 20px;
      background-color: var(--card-warm);
      border-radius: 12px;
      border: 1px solid var(--line);
      margin-bottom: 10px;
      color: var(--ink);
      .memory-heading {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 10px;
        width: 100%;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: var(--ink);

        @media (min-width: 576px) {
          max-width: 600px;
        }
      }
      .memory-date {
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        color: var(--quiet);
      }
      .category-wrap {
        position: relative;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
        @media (min-width: 576px) {
          flex-wrap: nowrap;
        }
        .category {
          text-transform: capitalize;
          font-size: 14px;
          line-height: 18px;
          font-weight: 400;
          padding: 5px 10px;
          border-radius: 16px;
          border: 1px solid var(--line);
          background: var(--o-tint);
          color: var(--o-deep);
        }
      }

      .icon-wrap {
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
      }
    }
  }

  .memory-disable {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 28px 20px;
    width: 100%;
    background-color: var(--card-warm);
    border-radius: 16px;
    border: 1px solid var(--line);
    color: var(--ink);

    .stick-wrap {
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 14px;
      background-color: var(--band);
      border-radius: 50%;

      img {
        width: 24px;
        height: 24px;
        color: var(--quiet);
      }
    }

    .disable-title {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      margin-bottom: 8px;
      color: var(--ink);
    }

    .disable-desc {
      width: 100%;
      max-width: 400px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      margin: 0 auto;
      color: var(--quiet);
      text-align: center;
    }
  }

  .react-select__multi-value__label {
    .tag-text {
      display: none;
    }
  }

  .react-select__single-value {
    .flex-wrap > .description {
      display: none;
    }
  }

  .header {
    width: 100%;
    margin: 0 0 20px;
    padding: 0 0 15px;
    border-bottom: 1px solid #cdcdcd;

    .heading {
      display: block;
      font-size: 20px;
      line-height: 24px;
    }
  }

  .title {
    display: block;
    font-size: 18px;
    line-height: 24px;
    margin: 0 0 8px;
    color: var(--text-color);
  }

  .builder-layout {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    align-items: start;

    @media (min-width: 1024px) {
      grid-template-columns: minmax(280px, 1fr) minmax(0, 2fr);
    }
  }

  .builder-sidebar,
  .builder-main {
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-width: 0;
  }

  .settings-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }
  }

  .builder-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 0 0 20px;

    @media (min-width: 992px) {
      grid-template-columns: 1fr 1fr 1fr;
      align-items: start;
    }
  }

  .panel {
    background: var(--card);
    border: 1px solid var(--line);
    border-radius: 22px;
    padding: 20px;
    box-shadow: var(--shadow);
    color: var(--ink);

    h3 {
      font-size: 14px;
      line-height: 18px;
      font-weight: 700;
      color: var(--ink);
      margin: 0 0 16px;
    }

    .panel-hint {
      margin: -8px 0 16px;
      font-size: 12px;
      line-height: 18px;
      color: var(--quiet);
    }

    .type-field {
      margin-top: 4px;
    }

    .type-label {
      display: block;
      margin: 0 0 8px;
      font-size: 14px;
      line-height: 18px;
      color: var(--ink);

      span {
        color: var(--o2);
      }
    }

    label,
    .label {
      color: var(--ink);
    }

    &.panel-instructions {
      textarea,
      .main-search,
      [class*='textarea'] {
        min-height: 220px;
      }
    }
  }

  .column-wrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0 0 10px;
    position: relative;

    @media (min-width: 576px) {
      flex-direction: row;
    }

    .column {
      width: 100%;
      flex-grow: 1;
      @media (min-width: 576px) {
        width: 49%;
      }
    }
  }

  .item-holder {
    width: 100%;
    margin: 0 0 20px;
    color: var(--quiet);

    p {
      margin: 0 0 20px;
    }
  }

  .react-select__control {
    padding-left: 10px;
  }

  .web-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    margin: 0 0 10px;

    .text-box {
      display: flex;
      align-items: center;
      gap: 6px;

      .icon {
        flex-shrink: 0;
        font-size: 20px;
        line-height: 1;
        color: var(--quiet);
      }
      .text {
        display: block;
        color: var(--ink);
      }
    }

    .btn {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 36px;
      border-radius: 10px;
      background: var(--o-tint);
      color: var(--o2);
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 8px;
  }

  label {
    position: relative;
  }

  .btn-prompt {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 18px;
    line-height: 1;
    width: 28px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
      border: 1px solid rgba(157, 157, 157, 0.2);
    }
  }

  .btn-domain {
    position: absolute;
    top: -2px;
    right: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    line-height: 18px;
    line-height: 1;
    border-radius: 5px;
    padding: 5px;
    cursor: pointer;
    border: 1px solid transparent;

    &:hover {
      border: 1px solid rgba(157, 157, 157, 0.3);
    }
  }
`;

export const MenuBtn = styled(MenuButton)`
  position: relative;
`;

export const TypeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const TypeBtn = styled.button`
  padding: 10px 8px;
  border-radius: 10px;
  border: 1px solid ${({ $active }) => ($active ? 'var(--o1)' : 'var(--line)')};
  background: ${({ $active }) => ($active ? 'var(--o-tint)' : 'var(--card)')};
  color: ${({ $active }) => ($active ? 'var(--o-deep)' : 'var(--fg-2)')};
  font-size: 13px;
  line-height: 16px;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: var(--o1);
    color: var(--ink);
    background: var(--o-tint);
  }
`;
